import fifaveClient, { fifthUrl } from '../services/fifthaveClient'

export interface QueryListResponse {
  createdAt: number
  createdBy: string
  images?: any[]
  lastUpdatedAt: number
  latestPurchasePriceFen: number
  productId: string
  state: "ON" | "OFF"
  targetPriceFen: number
}

export const queryList = data =>
         fifaveClient.post<{ data: QueryListResponse[] ,total:number}>(
           `api/v1/_internal/product-comparison/list`,
           
           {
             ...data,
             needTotal:true
           }
         )

export const editorState = (id: string, data) =>
         fifaveClient.patch(`api/v1/_internal/product-comparison/${id}`, data)
        

export const addProduct = data => fifaveClient.post(`api/v1/_internal/product-comparison`, data)
export const downProductList = data =>
         fifaveClient.post(`api/v1/_internal/product-comparison/_export`, data, {
           responseType: 'blob'
         })

export const uploadLink = `${fifthUrl}/api/v1/_internal/product-comparison/_upload`